// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"80ea4a38","465":"a1976586","511":"a086aba7"}[chunkId] + ".chunk.js";
};